<template>
  <div class="grid-view">
    <div class="main-content queryFinanceBalance">
      <search-item
        :key="identify"
        :ref="identify"
        :is-append-query="isAppendQuery"
        :show-more-scheme="true"
        :show-simple="showSimple"
        :expand-adv="true"
        :search-item-code="searchItemCode"
        :config-module="configModule"
        :grid-config-module="gridConfigModule"
        :auto-init="searchItemAutoInit"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="simQueryPlaceholder"
        :col-settings="colSettings"
        @advSearchItemCallBack="fetchData"
        @simSearchItemCallBack="fetchDataBykeyWord"
        @advToggle="scrollCallback"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
      >
        <template slot="operations">
          <el-button no="dataExport" type="primary" @click="toDataExport()">{{ $t('CargoMsg.Cargo_DataExport') }}</el-button>
        </template>
        <template slot="searchAreaHeader">
          <slot name="searchAreaHeader" />
        </template>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          ref="gridFinanceBalance"
          :export-file-name="$t('AdvancePayment.FinanceBalance')"
          :config-module="gridConfigModule"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :min-height="'350px'"
        />
      </div>
      <div id="footer-wrapper-tab-financebalance" class="pagination-wrapper">
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="searchConditions.total"
            layout="total"
          />
        </div>
        <cargo-pagination
          v-show="!appendQuery"
          ref="paginationFinanceBalance"
          :config-module="gridConfigModule"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { cacheName, cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import { queryFinanceBalanceList } from '@/api/clearing/advancePayment'
import lodash from 'lodash'
import { formatNumberToThousands } from '@/utils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'QueryFinanceBalance',
  components: { searchItem },
  props: {
    isAppendQuery: { type: Boolean, default: false }, // 追加查询，默认不显示
    identify: { type: String, default: 'queryFinanceBalance' }, // ID
    configModule: { type: String, default: '5153' }, // 高级查询条件
    gridConfigModule: { type: String, default: '191403' }, // 列表设置
    showSimple: { type: Boolean, default: true },
    colSettings: { type: Object }
  },
  data() {
    return {
      loading: false,
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      searchItemCode: '查询预付款余额',
      simQueryPlaceholder: this.$t('AdvancePayment.QuickSearchBalance'),
      perConfigName: '',
      gridRefreshId: 0,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowSelected: this.onRowSelected,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      columnDefs: [
        { headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('AdvancePayment.CustomerName'), field: 'customerName', initialWidth: 200, minWidth: 200 },
        { headerName: this.$t('AdvancePayment.CustomerCode'), field: 'customerCode', initialWidth: 130, minWidth: 130 },
        { headerName: this.$t('AdvancePayment.SalesName'), field: 'salesName', initialWidth: 100, minWidth: 100 },
        { headerName: this.$t('AdvancePayment.ParentBranchName'), field: 'parentBranchName', initialWidth: 200, minWidth: 200 },
        { headerName: this.$t('AdvancePayment.ParentBranchCode'), field: 'parentBranchCode', initialWidth: 130, minWidth: 130 },
        { headerName: this.$t('AdvancePayment.BranchName'), field: 'branchName', initialWidth: 200, minWidth: 200 },
        { headerName: this.$t('AdvancePayment.BranchCode'), field: 'branchCode', initialWidth: 130, minWidth: 130 },
        { headerName: this.$t('AdvancePayment.FinanceBalance'), field: 'balance', initialWidth: 100, minWidth: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        { headerName: this.$t('AdvancePayment.FinanceUpdateDate'), field: 'financeUpdateDate', initialWidth: 120, minWidth: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('AdvancePayment.SyncDate'), field: 'syncDate', initialWidth: 120, minWidth: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('AdvancePayment.Currency'), field: 'currency', initialWidth: 100, minWidth: 100 }
      ],
      rowData: [],
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        snapshotConditions: [], // 高级查询条件
        requires: []
      },
      selectedItem: {}, // 表格选中项
      selections: [], // 已经选中列表
      shouldFixed: false,
      appendQuery: false, // 追加查询
      queryOfficeId: 0 // 记录查询时的分公司Id
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.initCustomSearchItems()
  },
  methods: {
    // 查询
    fetchData(conditions, simpleTriggerMode = false) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      // 高级查询条件组装
      if (!simpleTriggerMode) {
        const advConditions = lodash.cloneDeep(conditions)
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(advConditions)
        //
        finallyConditions.push(...advConditions)
      } else {
        finallyConditions.push(...conditions)
      }
      // 【是否显示下级公司】，是根据【揽收机构】来的
      if (AdvancedSearchOption.hasField('showChildData', finallyConditions) && !AdvancedSearchOption.hasField('advancePayment.BRANCH_ID', finallyConditions)) {
        AdvancedSearchOption.removeOption('showChildData', finallyConditions)
      }
      console.log(finallyConditions)
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      this.toQueryFinanceBalanceList()
    },
    // 快捷检索
    fetchDataBykeyWord(keyWord) {
      console.log('fetchDataBykeyWord', keyWord)
      if (!StrUtils.isEmpty(keyWord)) {
        const conditions = []
        const option = new AdvancedSearchOption(null, 'advancePayment.CUSTOMER_CODE', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        //
        this.appendQuery = false
        this.fetchData(conditions, true)
      }
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toQueryFinanceBalanceList()
    },
    toQueryFinanceBalanceList() {
      this.queryOfficeId = this.$store.getters.currentOfficeId
      const { snapshotConditions: conditions, requires: requires, pageNum, pageSize } = this.searchConditions
      const requestBody = { conditions, requires, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize }
      requestBody.appendQuery = this.appendQuery
      this.loading = getLoading()
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      queryFinanceBalanceList(requestBody).then(res => {
        let results = res.data.list
        // 追加查询数据去重
        if (this.appendQuery) {
          results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
        }
        this.rowData = results
        this.searchConditions.total = this.appendQuery ? results.length : Number(res.data.total)
        selectedStatus.revert()
      }).finally(() => {
        this.loading.close()
      })
    },
    async initCustomSearchItems() {
      const defaultSearchFields = []
      //

      if (defaultSearchFields.length > 0) {
        this.customSearchItems.push(...defaultSearchFields)
        this.searchItemAutoInit = true
      }
    },
    onRowSelected(event) {
      console.log('onRowSelected', event.data)
      this.selectedItem = {}
      if (event.node.selected && event.data) {
        this.selectedItem = event.data
      }
    },
    onRowClicked(event) {
      console.log('onRowClicked', event.data)
      this.selectedItem = event.data
    },
    onRowDoubleClicked(event) {
      console.log('onRowDoubleClicked', event.data)
      this.selectedItem = event.data
      this.$emit('rowDoubleClicked', this.selectedItem)
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.parent-wrapper')
        const footer = document.getElementById('footer-wrapper-tab-financebalance')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (offset > containerHeight) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    // 获取勾选的项目
    getSelections() {
      return getGridSelected(this.gridOptions)
    },
    // 导出
    toDataExport() {
      this.$refs.gridFinanceBalance.handleExportSelectedToExcel(this.gridOptions)
    }
  }
}
</script>
